import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { useVendorsApiClient } from 'vendors/api/useVendorsApiClient'

export const useEnsurementRequest = (): UseMutationResult<void, unknown, EnsurementRequestType, unknown> => {
  const { ensurementRequest } = useVendorsApiClient()

  return useMutation({
    mutationFn: (payload: EnsurementRequestType) => ensurementRequest(payload)
  })
}
